import { render, staticRenderFns } from "./domain-history-section.html?vue&type=template&id=3695520e&scoped=true&"
import script from "./domain-history-section.js?vue&type=script&lang=js&"
export * from "./domain-history-section.js?vue&type=script&lang=js&"
import style0 from "./domain-history-section.scss?vue&type=style&index=0&id=3695520e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3695520e",
  null
  
)

export default component.exports